export default __webpack_public_path__ + "static/beanocard-1-8844050963dba7cd9ae4aa400ed66bcf.png";